import { Component } from '@angular/core';
import { Title,Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-website-devolpment',
  templateUrl: './website-devolpment.component.html',
  styleUrls: ['./website-devolpment.component.css']
})
export class WebsiteDevolpmentComponent {
 
  constructor(private titleServvice:Title,private metaService: Meta){}

  ngOnInit(): void {
    this.titleServvice.setTitle('Professional Web Development Company in Hyderabad | Sharkify AI')
    this.metaService.addTags([
      { name: 'description', content: 'Sharkify AI is the professional web development company in Hyderabad. We design custom, innovative, and user-friendly websites to help your business grow online.' },
      { name: 'keywords', content: 'Best web development company in Hyderabad' }
    ]);
  }
}
